import lodash from 'lodash';
import { composeReducers } from 'common/util/composeReducers';
import { ACTIONS } from 'forms/actions/sdfa';

export function loadDocumentActions(state, action) {
    if (!action || action.type !== ACTIONS.LOAD_DOCUMENT_ACTIONS) {
        return state;
    }

    const newState = {
        ...state
    };

    newState.documentActions = action.payload;

    return newState;
}

export function loadSDFAContextData(state, action) {
    if (!action || action.type !== ACTIONS.SDFA_LOAD_CONTEXT_DATA) {
        return state;
    }

    return {
        ...state,
        sdfa: {
            ...state.sdfa,
            binderTitle: action.payload.binderTitle,
            documentName: action.payload.documentName,
        }
    };
}

export function loadBinderUsers(state, action) {
    if (!action || action.type !== ACTIONS.LOAD_BINDER_USERS) {
        return state;
    }

    const newState = {
        ...state,
    };
    newState.binderUsers = action.payload;

    return newState;
}

export function loadUsersForSDFA(state, action) {
    if (!action || action.type !== ACTIONS.LOAD_USERS_FOR_SDFA) {
        return state;
    }
    const { externalUsers, institutionUsers } = action.payload;
    const { binderUsers } = state;

    const users = createUsersList(institutionUsers, externalUsers);
    const externalUsersList = lodash.keyBy(externalUsers, 'id');
    const studyMembers = createStudyMembersList(binderUsers, externalUsersList, users);
    const newState = {
        ...state,
        studyMembers,
        users,
    };
    return newState;
}

export function reloadUsersForSDFA(state, action) {
    if (!action || action.type !== ACTIONS.RELOAD_USERS_FOR_SDFA) {
        return state;
    }
    const { externalUsers, institutionUsers } = action.payload;
    const users = createUsersList(institutionUsers, externalUsers);
    const newState = {
        ...state,
        users,
    };
    return newState;
}

function createUsersList(institutionUsers, externalUsers){
    const users = lodash.union(institutionUsers, externalUsers);
    const usersList = users.map(user => lodash.pick(user, ['id', 'displayName', 'firstName', 'lastName', 'sub', 'emailAddress',]));
    return lodash.keyBy(usersList, 'id');
}

function createStudyMembersList(binderUsers, externalUsers, users){
    let studyMembers = [];
    binderUsers.forEach(currentUser =>
    {
        const externalUser = lodash.get(externalUsers, currentUser.id);
        const internalUser = lodash.get(users, currentUser.id);
        if(!externalUser && internalUser) {
            studyMembers.push(internalUser);
        }
        return studyMembers;
    });
    return lodash.keyBy(studyMembers, 'id');
}

export function sdfaSuccess(state, action) {
    if (!action || action.type !== ACTIONS.SDFA_SUCCESS) {
        return state;
    }

    const newState = {
        ...state
    };

    newState.sdfa = action.payload;

    return newState;
}

export function clearSDFA(state, action) {
    if (!action || action.type !== ACTIONS.CLEAR_SDFA) {
        return state;
    }

    const newState = {
        ...state
    };

    delete newState.sdfa;
    delete newState.users;
    delete newState.adminUsers;

    return newState;
}

export function writeSdfaInboxItem(state, action) {
    if (!action || action.type !== ACTIONS.SDFA_WRITE_INBOX_ITEM) {
        return state;
    }

    const { inboxItem } = action.payload;

    return {
        ...state,
        form: { inboxItem }
    };
}

export function writeSdfaSentItem(state, action) {
    if (!action || action.type !== ACTIONS.SDFA_WRITE_SENT_ITEM) {
        return state;
    }
    const { sentItem } = action.payload;

    return {
        ...state,
        form: { sentItem }
    };
}

export function clearSdfaItem(state, action) {
    if (!action || action.type !== ACTIONS.SDFA_CLEAR_ITEM) {
        return state;
    }

    return {
        ...state,
        form: {}
    };
}

function writeSdfaTaskCompletion(state, action) {
    if (!action || action.type !== ACTIONS.SDFA_TASK_COMPLETION) {
        return state;
    }

    const { success } = action.payload;
    const form = state.form;

    return {
        ...state,
        form: {
            ...form,
            submissionSuccess: success
        }
    };
}

function updateCanceledSdfaTask(state, action) {
    if (!action || action.type !== ACTIONS.SDFA_CANCEL_UPDATE) {
        return state;
    }

    const form = state.form;
    const sentItem = form.sentItem;
    const tasks = sentItem.tasks;
    const taskIndex = lodash.findIndex(tasks, task => task.id === action.payload);
    const task = {...tasks[taskIndex], deleted: true};
    const updatedTasks = [...tasks];
    updatedTasks[taskIndex] = task;

    return {
        ...state,
        form: {
            ...form,
            sentItem: {
                ...sentItem,
                tasks: updatedTasks,
            },
        }
    };

}

export default composeReducers(
    loadDocumentActions,
    loadBinderUsers,
    loadUsersForSDFA,
    reloadUsersForSDFA,
    sdfaSuccess,
    clearSDFA,
    writeSdfaInboxItem,
    clearSdfaItem,
    writeSdfaTaskCompletion,
    writeSdfaSentItem,
    updateCanceledSdfaTask,
    loadSDFAContextData,
);
